import type {ReactNode} from 'react'
import {KairosMark} from '@/components/kairos-mark'

/** `accion` es el único primario de la vista, a la derecha del `<h1>` (U7). Sin `accion` el
 * marcado sale idéntico, a propósito, y una vista de solo lectura no inventa uno. */
export function PageHeading({
  title,
  subtitle,
  accion,
  ayuda,
}: {
  title: string
  /** Solo un dato (período, alcance, conteo), nunca prosa que explique la pantalla (T1). */
  subtitle?: ReactNode
  accion?: ReactNode
  /** El `HelpIcon` de la pantalla (U6), pegado al `<h1>`. */
  ayuda?: ReactNode
}) {
  const bloque = (
    <div>
      <div className="flex items-center gap-2 text-foreground">
        <KairosMark />
        <h1 className="font-heading text-xl tracking-tight">{title}</h1>
        {ayuda}
      </div>
      {subtitle && <p className="mt-1.5 text-sm text-muted-foreground">{subtitle}</p>}
    </div>
  )
  if (!accion) return bloque
  return (
    <div className="flex flex-wrap items-start justify-between gap-3">
      {bloque}
      <div className="shrink-0" data-testid="page-heading-accion">
        {accion}
      </div>
    </div>
  )
}
